module.exports = __webpack_public_path__ + "static/media/asterisk.c1d3cdf9.svg";